import React from 'react'
// components
import ProductListItem from './ProductListItem'

const ProductList = (props) => {
  const {  productList, defaultSpace, ...itemProps } = props
  return <div className="product-list_com">
    {
      productList.length > 0 ? (
        productList.map((item, index) => {
          return (
            <ProductListItem {...itemProps}
                item={item}
                key={index} ></ProductListItem>
          )
        })
      ):
      defaultSpace()
    }
  </div>
}

export default ProductList